import { loggerApp } from "../../logger/index.js";
import { getImageSizes } from "./formatVehicleImages.js";
import { formatVehicleTitle } from "./formatVehicleTitle.js";
const YOUTUBE_PREVIEW_SIZE_MAP = {
  [
    "default"
    /* xs */
  ]: 120,
  [
    "mqdefault"
    /* sm */
  ]: 320,
  [
    "hqdefault"
    /* md */
  ]: 480,
  [
    "sddefault"
    /* lg */
  ]: 640,
  [
    "maxresdefault"
    /* xl */
  ]: 1280
};
function getIDfromURL(url) {
  if (!url) {
    return null;
  }
  const re = /(https?:\/\/)?(((m|www)\.)?(youtube(-nocookie)?|youtube.googleapis)\.com.*(v\/|v=|vi=|vi\/|e\/|embed\/|user\/.*\/u\/\d+\/)|youtu\.be\/)([_0-9a-z-]+)/i;
  const match = url.match(re);
  if (match && match[8].length === 11) {
    return match[8];
  }
  loggerApp.log([
    {
      type: "info",
      message: "Format vehicle videos",
      items: [
        {
          message: "Предоставленный URL-адрес не является допустимым URL-адресом YouTube."
        }
      ]
    }
  ]);
  return null;
}
const transformUrl = (videoId) => {
  return `https://www.youtube.com/embed/${videoId}?autoplay=1&showinfo=0`;
};
const getYoutubePreview = (videoId, size) => {
  return `https://img.youtube.com/vi/${videoId}/${size}.jpg`;
};
const transformYoutubePreview = (videoId, title) => {
  return {
    sizes: getImageSizes("card").join(","),
    title,
    original: getYoutubePreview(
      videoId,
      "maxresdefault"
      /* xl */
    ),
    thumbnail: getYoutubePreview(
      videoId,
      "mqdefault"
      /* sm */
    ),
    srcSet: Object.entries(YOUTUBE_PREVIEW_SIZE_MAP).map(([size, width]) => {
      return `${getYoutubePreview(videoId, size)} ${width}w`;
    }).join(",")
  };
};
const formatVehicleVideos = (extItem) => {
  const { videos } = extItem.data;
  const title = formatVehicleTitle(extItem);
  if (!(videos == null ? void 0 : videos.length)) {
    return [];
  }
  const videoIds = [];
  for (const video of videos) {
    const videoId = getIDfromURL(video);
    if (videoId) {
      videoIds.push(videoId);
    }
  }
  return videoIds.map((videoId) => ({
    url: transformUrl(videoId),
    preview: transformYoutubePreview(videoId, title)
  }));
};
export {
  formatVehicleVideos
};
